import React, { useState, useEffect } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import languageData from "./languages.json";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import Accordion from "react-bootstrap/Accordion";
import Logo from "./logo.png";
import Footer from "./components/Footer/Footer";

function App() {
  const [numPlayers, setNumPlayers] = useState(0);
  const [assignedCards, setAssignedCards] = useState([]);
  const [currentPlayer, setCurrentPlayer] = useState(null);
  const [isCardVisible, setIsCardVisible] = useState(false);
  const [language, setLanguage] = useState("en");
  const [cardCounts, setCardCounts] = useState({});
  const [totalCardCount, setTotalCardCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false); // Added state for modal visibility
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false); // Added state for modal visibility

  useEffect(() => {
    if (Object.keys(cardCounts).length) {
      loadCardsForLanguage(language);
    }
  }, [language]);

  const loadCardsForLanguage = (lang) => {
    const selectedCards = [];
    for (const cardId in cardCounts) {
      const count = cardCounts[cardId];
      for (let i = 0; i < count; i++) {
        selectedCards.push(languageData[lang].cards[cardId]);
      }
    }
    const shuffledCards = selectedCards.sort(() => 0.5 - Math.random());
    setAssignedCards(shuffledCards.slice(0, numPlayers));
  };

  const startGame = () => {
    if (numPlayers < 1) {
      alert("Please enter a valid number of players.");
      return;
    }
    if (totalCardCount !== numPlayers) {
      alert(
        `Total selected cards must equal the number of players: ${numPlayers}`
      );
      return;
    }
    loadCardsForLanguage(language);
    setCurrentPlayer(0);
    setIsCardVisible(false);
  };

  const showCard = () => {
    setIsCardVisible(true);
  };

  const closeCard = () => {
    setIsCardVisible(false);
    if (currentPlayer < numPlayers - 1) {
      setCurrentPlayer(currentPlayer + 1);
    } else {
      <Alert key="danger" variant="danger">
        This is alert—check it out!
      </Alert>;
      // alert("All players have seen their cards.");
      <div className="modalOverlay">
          <div className="modalContent">
            <h2>{lang.rulesTitle || "Game Rules"}</h2>
            <div dangerouslySetInnerHTML={{ __html: lang.rulesBody1 }} />
            <div dangerouslySetInnerHTML={{ __html: lang.rulesBody2 }} />
            <div dangerouslySetInnerHTML={{ __html: lang.rulesBody3 }} />
            <button onClick={() => setIsModalOpen(false)}>
              {lang.closeButton || "Close"}
            </button>
          </div>
        </div>
      setCurrentPlayer(null);
    }
  };

  const toggleLanguage = (lang) => {
    setLanguage(lang);
  };

  const updateCardCount = (cardId, change) => {
    const newCount = (cardCounts[cardId] || 0) + change;
    if (newCount >= 0) {
      const updatedCounts = { ...cardCounts, [cardId]: newCount };
      const newTotal = Object.values(updatedCounts).reduce(
        (sum, value) => sum + value,
        0
      );
      if (newTotal <= numPlayers) {
        setCardCounts(updatedCounts);
        setTotalCardCount(newTotal);
      } else {
        alert(
          `Total card count cannot exceed the number of players: ${numPlayers}`
        );
      }
    }
  };

  const lang = languageData[language];

  return (
    <div className="App">
      <Navbar expand="lg" bg="success" data-bs-theme="dark">
        <Container>
          <Navbar.Brand href="/">
            <img
              src="./logo.png" // Replace with your logo URL
              alt="Logo"
              width="150"
              height="60"
              className="d-inline-block align-top"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="justify-content-end flex-grow-1 pe-3">
              {/* <LanguageSelector currentLanguage={language} toggleLanguage={toggleLanguage} /> */}
              <Nav.Link
                onClick={() => setIsSecondModalOpen(true)}
                className="rulesButton"
              >
                {lang.aboutTitle || "Խաղի մասին"}
              </Nav.Link>
              <Nav.Link
                onClick={() => setIsModalOpen(true)}
                className="rulesButton"
              >
                {lang.rulesButton || "Rules"}
              </Nav.Link>
              <Nav.Link
                onClick={() => toggleLanguage("en")}
                // className={currentLanguage === 'en' ? 'active' : ''}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <path fill="#102f9b" d="M1 11H31V21H1z"></path>
                  <path
                    d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z"
                    fill="#c82a20"
                  ></path>
                  <path
                    d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z"
                    transform="rotate(180 16 24)"
                    fill="#e8ad3b"
                  ></path>
                  <path
                    d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z"
                    opacity=".15"
                  ></path>
                  <path
                    d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z"
                    fill="#fff"
                    opacity=".2"
                  ></path>
                </svg>
              </Nav.Link>
              <Nav.Link
                onClick={() => toggleLanguage("es")}
                // className={currentLanguage === 'es' ? 'active' : ''}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <rect
                    x="1"
                    y="4"
                    width="30"
                    height="24"
                    rx="4"
                    ry="4"
                    fill="#fff"
                  ></rect>
                  <path
                    d="M1.638,5.846H30.362c-.711-1.108-1.947-1.846-3.362-1.846H5c-1.414,0-2.65,.738-3.362,1.846Z"
                    fill="#a62842"
                  ></path>
                  <path
                    d="M2.03,7.692c-.008,.103-.03,.202-.03,.308v1.539H31v-1.539c0-.105-.022-.204-.03-.308H2.03Z"
                    fill="#a62842"
                  ></path>
                  <path fill="#a62842" d="M2 11.385H31V13.231H2z"></path>
                  <path
                    fill="#a62842"
                    d="M2 15.077H31V16.923000000000002H2z"
                  ></path>
                  <path fill="#a62842" d="M1 18.769H31V20.615H1z"></path>
                  <path
                    d="M1,24c0,.105,.023,.204,.031,.308H30.969c.008-.103,.031-.202,.031-.308v-1.539H1v1.539Z"
                    fill="#a62842"
                  ></path>
                  <path
                    d="M30.362,26.154H1.638c.711,1.108,1.947,1.846,3.362,1.846H27c1.414,0,2.65-.738,3.362-1.846Z"
                    fill="#a62842"
                  ></path>
                  <path
                    d="M5,4h11v12.923H1V8c0-2.208,1.792-4,4-4Z"
                    fill="#102d5e"
                  ></path>
                  <path
                    d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z"
                    opacity=".15"
                  ></path>
                  <path
                    d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z"
                    fill="#fff"
                    opacity=".2"
                  ></path>
                  <path
                    fill="#fff"
                    d="M4.601 7.463L5.193 7.033 4.462 7.033 4.236 6.338 4.01 7.033 3.279 7.033 3.87 7.463 3.644 8.158 4.236 7.729 4.827 8.158 4.601 7.463z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M7.58 7.463L8.172 7.033 7.441 7.033 7.215 6.338 6.989 7.033 6.258 7.033 6.849 7.463 6.623 8.158 7.215 7.729 7.806 8.158 7.58 7.463z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M10.56 7.463L11.151 7.033 10.42 7.033 10.194 6.338 9.968 7.033 9.237 7.033 9.828 7.463 9.603 8.158 10.194 7.729 10.785 8.158 10.56 7.463z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M6.066 9.283L6.658 8.854 5.927 8.854 5.701 8.158 5.475 8.854 4.744 8.854 5.335 9.283 5.109 9.979 5.701 9.549 6.292 9.979 6.066 9.283z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M9.046 9.283L9.637 8.854 8.906 8.854 8.68 8.158 8.454 8.854 7.723 8.854 8.314 9.283 8.089 9.979 8.68 9.549 9.271 9.979 9.046 9.283z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M12.025 9.283L12.616 8.854 11.885 8.854 11.659 8.158 11.433 8.854 10.702 8.854 11.294 9.283 11.068 9.979 11.659 9.549 12.251 9.979 12.025 9.283z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M6.066 12.924L6.658 12.494 5.927 12.494 5.701 11.799 5.475 12.494 4.744 12.494 5.335 12.924 5.109 13.619 5.701 13.19 6.292 13.619 6.066 12.924z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M9.046 12.924L9.637 12.494 8.906 12.494 8.68 11.799 8.454 12.494 7.723 12.494 8.314 12.924 8.089 13.619 8.68 13.19 9.271 13.619 9.046 12.924z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M12.025 12.924L12.616 12.494 11.885 12.494 11.659 11.799 11.433 12.494 10.702 12.494 11.294 12.924 11.068 13.619 11.659 13.19 12.251 13.619 12.025 12.924z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M13.539 7.463L14.13 7.033 13.399 7.033 13.173 6.338 12.947 7.033 12.216 7.033 12.808 7.463 12.582 8.158 13.173 7.729 13.765 8.158 13.539 7.463z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M4.601 11.104L5.193 10.674 4.462 10.674 4.236 9.979 4.01 10.674 3.279 10.674 3.87 11.104 3.644 11.799 4.236 11.369 4.827 11.799 4.601 11.104z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M7.58 11.104L8.172 10.674 7.441 10.674 7.215 9.979 6.989 10.674 6.258 10.674 6.849 11.104 6.623 11.799 7.215 11.369 7.806 11.799 7.58 11.104z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M10.56 11.104L11.151 10.674 10.42 10.674 10.194 9.979 9.968 10.674 9.237 10.674 9.828 11.104 9.603 11.799 10.194 11.369 10.785 11.799 10.56 11.104z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M13.539 11.104L14.13 10.674 13.399 10.674 13.173 9.979 12.947 10.674 12.216 10.674 12.808 11.104 12.582 11.799 13.173 11.369 13.765 11.799 13.539 11.104z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M4.601 14.744L5.193 14.315 4.462 14.315 4.236 13.619 4.01 14.315 3.279 14.315 3.87 14.744 3.644 15.44 4.236 15.01 4.827 15.44 4.601 14.744z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M7.58 14.744L8.172 14.315 7.441 14.315 7.215 13.619 6.989 14.315 6.258 14.315 6.849 14.744 6.623 15.44 7.215 15.01 7.806 15.44 7.58 14.744z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M10.56 14.744L11.151 14.315 10.42 14.315 10.194 13.619 9.968 14.315 9.237 14.315 9.828 14.744 9.603 15.44 10.194 15.01 10.785 15.44 10.56 14.744z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M13.539 14.744L14.13 14.315 13.399 14.315 13.173 13.619 12.947 14.315 12.216 14.315 12.808 14.744 12.582 15.44 13.173 15.01 13.765 15.44 13.539 14.744z"
                  ></path>
                </svg>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {currentPlayer === null ? (
        <>
          <CardSelection
            numPlayers={numPlayers}
            setNumPlayers={setNumPlayers}
            startGame={startGame}
            subtitle={lang.subtitle}
            startButton={lang.startButton}
          />

          <Accordion defaultActiveKey="0" className="custom-accordion">
            <Accordion.Item eventKey="0">
              <Accordion.Header>{lang.accordion}</Accordion.Header>
              <Accordion.Body>
                <CardCountAccordion
                  cards={languageData[language].cards}
                  cardCounts={cardCounts}
                  updateCardCount={updateCardCount}
                  totalCardCount={totalCardCount}
                  numPlayers={numPlayers}
                  lang={lang}
                />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>{lang.accordionSituation}</Accordion.Header>
              <Accordion.Body>
                
                <Infocards
                 cards={languageData[language].situationcards}
                 lang={lang} 
                 cardCounts={cardCounts}
                 title={languageData[language].accordionSituation}/>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>{lang.accordionInfocards}</Accordion.Header>
              <Accordion.Body>
                <Infocards
                 cards={languageData[language].infocards}
                 lang={lang} 
                 cardCounts={cardCounts}
                 title={languageData[language].accordionInfocards}/>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <Footer 
          footertext={lang.footer}
          footertext_project={lang.footertext_project}
          footertext_fund={lang.footertext_fund} />
        </>
      ) : (
        <CardReveal
          playerIndex={currentPlayer}
          card={assignedCards[currentPlayer]}
          isCardVisible={isCardVisible}
          showCard={showCard}
          closeCard={closeCard}
          lang={lang}
        />
      )}

      {isModalOpen && (
        <div className="modalOverlay">
          <div className="modalContent">
            <h2>{lang.rulesTitle || "Game Rules"}</h2>
            <div dangerouslySetInnerHTML={{ __html: lang.rulesBody1 }} />
            <div dangerouslySetInnerHTML={{ __html: lang.rulesBody2 }} />
            <div dangerouslySetInnerHTML={{ __html: lang.rulesBody3 }} />
            <button onClick={() => setIsModalOpen(false)}>
              {lang.closeButton || "Close"}
            </button>
          </div>
        </div>
      )}
      {isSecondModalOpen && (
        <div className="modalOverlay">
          <div className="modalContent">
            <h2>{lang.aboutTitle || "Game Rules"}</h2>
            <div dangerouslySetInnerHTML={{ __html: lang.aboutBody }} />
            <button onClick={() => setIsSecondModalOpen(false)}>
              {lang.closeButton || "Close"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// function LanguageSelector({ currentLanguage, toggleLanguage }) {
//   return (

//     <div className="LanguageSelector">
//       <Navbar.Toggle aria-controls="basic-navbar-nav" />
//       <Navbar.Collapse id="basic-navbar-nav">
//       <Nav>
//       <Nav.Link
//         onClick={() => toggleLanguage('en')}
//         className={currentLanguage === 'en' ? 'active' : ''}
//       >
//         🇬🇧 English
//       </Nav.Link>
//       <Nav.Link
//         onClick={() => toggleLanguage('es')}
//         className={currentLanguage === 'es' ? 'active' : ''}
//       >
//         🇪🇸 Español
//       </Nav.Link>
//       </Nav>
//       </Navbar.Collapse>
//     </div>

//   );
// }

function CardSelection({
  numPlayers,
  setNumPlayers,
  startGame,
  subtitle,
  startButton,
}) {
  return (
    <div className="CardSelection">
      <label>{subtitle}</label>
      <input
        type="text"
        value={numPlayers}
        onChange={(e) => setNumPlayers(parseInt(e.target.value) || 0)}
        min="1"
      />
      <button onClick={startGame}>{startButton}</button>
    </div>
  );
}

function CardCountAccordion({
  cards,
  cardCounts,
  updateCardCount,
  totalCardCount,
  numPlayers,
  lang,
}) {
  return (
    <div className="CardCountAccordion">
      <h2>{lang.cardSelectionTitle}</h2>
      <p className="totalCardCount">
        {lang.totalCardCount}: {totalCardCount}/{numPlayers}
      </p>
      {cards.map((card, index) => (
        <div key={index} className="AccordionSection">
          <div className="AccordionHeader">
            <span>{card.title}</span>
            <div className="cardCountControls">
              <button onClick={() => updateCardCount(index, -1)}>-</button>
              <span>{cardCounts[index] || 0}</span>
              <button onClick={() => updateCardCount(index, 1)}>+</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
function Infocards({
  cards,
  cardCounts,
  lang,
  title
}) {
  return (
    <div className="InfocardAccordion">
      <h2>{title}</h2>
      {cards.map((card, index) => (
        <div key={index} className="InfocardsSection">
          <div className="InfocardHeader">
            
            <p>{card.title}</p>
            <span>{card.body}</span>
            
          </div>
        </div>
      ))}
    </div>
  );
}

function CardReveal({
  playerIndex,
  card,
  isCardVisible,
  showCard,
  closeCard,
  lang,
}) {
  let audio = new Audio(card.sound);
  const start = () => {
    audio.play();
  };

  const stopAudio = () => {
    audio.pause(); // Stop the audio
    audio.currentTime = 0; // Reset playback position
    closeCard(); // Trigger the `closeCard` function
  };
  return (
    <div className="CardReveal">
      <h3>
        {(lang.playerCardTitle || "Player {player}'s Card").replace(
          "{player}",
          playerIndex + 1
        )}
      </h3>
      {isCardVisible ? (
        <div className="cardContent">
          <h4>{card.title}</h4>
          {card.sound && (
            <button onClick={start}>
              <svg
                width="24"
                height="24"
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
              >
                <path d="M15 23l-9.309-6h-5.691v-10h5.691l9.309-6v22zm-9-15.009v8.018l8 5.157v-18.332l-8 5.157zm14.228-4.219c2.327 1.989 3.772 4.942 3.772 8.229 0 3.288-1.445 6.241-3.77 8.229l-.708-.708c2.136-1.791 3.478-4.501 3.478-7.522s-1.342-5.731-3.478-7.522l.706-.706zm-2.929 2.929c1.521 1.257 2.476 3.167 2.476 5.299 0 2.132-.955 4.042-2.476 5.299l-.706-.706c1.331-1.063 2.182-2.729 2.182-4.591 0-1.863-.851-3.529-2.184-4.593l.708-.708zm-12.299 1.299h-4v8h4v-8z" />
              </svg>
            </button>
          )}
          <p>{card.subtitle}</p>
          <p>{card.body}</p>
          <button onClick={stopAudio}>{lang.closeButton || "Close"}</button>
        </div>
      ) : (
        <button onClick={showCard}>{lang.showButton || "Show Card"}</button>
      )}
    </div>
  );
}

function PadletEmbed() {
  return (
    <div
      className="padlet-embed"
      style={{
        border: "1px solid rgba(0,0,0,0.1)",
        borderRadius: "2px",
        boxSizing: "border-box",
        overflow: "hidden",
        position: "relative",
        width: "100%",
        background: "#F4F4F4",
      }}
    >
      <p style={{ padding: 0, margin: 0 }}>
        <iframe
          src="https://padlet.com/embed/6fnb0stv45esnrcy"
          frameBorder="0"
          allow="camera;microphone;geolocation"
          style={{
            width: "100%",
            height: "608px",
            display: "block",
            padding: 0,
            margin: 0,
          }}
        ></iframe>
      </p>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          margin: 0,
          height: "28px",
        }}
      >
        <a
          href="https://padlet.com?ref=embed"
          style={{
            display: "block",
            flexGrow: 0,
            margin: 0,
            border: "none",
            padding: 0,
            textDecoration: "none",
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src="https://padlet.net/embeds/made_with_padlet_2022.png"
              width="114"
              height="28"
              style={{
                padding: 0,
                margin: 0,
                background: "transparent",
                border: "none",
                boxShadow: "none",
              }}
              alt="Made with Padlet"
            />
          </div>
        </a>
      </div>
    </div>
  );
}

export default App;
